import { SERVER_URL } from "./config";


const groupNames = ["group-1", "group-2", "group-3", "group-7", "group-8"];

function getISTDateTimeLocal() {
  const now = new Date();
  const offsetInMinutes = now.getTimezoneOffset();
  const localIST = new Date(now.getTime() - offsetInMinutes * 60000);
  return localIST.toISOString().slice(0, 16);
}

const groupInfo = {
  "group-1": [
    {
      label: "Lorry No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        tds_rate: "tds_rate",
        pan_no: "pan_no",
      },
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      keyboardNavigationMap: {
        Enter: "payable_branch_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    
    {
      label: "Paid At",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payable_branch_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "payable_branch",
        name: "payable_branch_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "truck_hire",
      },
    },

  ],
  "group-2": [ 
    {
      label: "Hire Fixed",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "truck_hire",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "advance_bhada",
      },
    },
    {
      label: "Adv. Paid",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "advance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "balance_bhada",
      },
    },
  
    {
      label: "Cash Paid",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "cash_paid",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "balance_bhada",
      },
    },    
    {
      label: "Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "balance_bhada",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "total_weight",
      },
    },  
  ],
  "group-4": [
    {
      label: "Total Weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_weight",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "door_del_weight",
      },
    },
    {
      label: "Door Del Weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "door_del_weight",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "payable_weight",
      },
    },
    {
      label: "Payable Weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "payable_weight",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "narration",
      },
    },
     {
      label: "Narration",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "narration",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
    // {
    //   label: "Remarks",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "remarks",
    //   type: "text",
    //   placeHolder: "",
    //   keyboardNavigationMap: {
    //     Enter: "save_button",
    //   },
    // },
  ],
  "group-8": [
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_to_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      suggestionSchema: {
        branch_id: "station_to",
        name: "station_to_name",
        adderss: "address",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        required: (pageState) => {
            return pageState.station_to != "";
        },
        Enter: "destination_name",
      },
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "station_to",
    },
    {
      label: "Articles Excess",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "article_excess",
      type: "text",
      placeHolder: "",
      // apiConfigKey: "getCitySuggestions",
      // url: SERVER_URL + "/branch/",
      // suggestionKeyword: "name",
      // suggestionKeywordForFetchApiArgs: "name",
      // suggestionChooseQueryKeyword: "branch_id",
      apiCallRequiredOnGetValue: true,
      // suggestionSchema: {
      //   branch_id: "station_to",
      //   name: "station_to_name",
      //   adderss: "address",
      // },
      // toValidate: true,
      // regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        required: (pageState) => {
            return pageState.station_to != "";
        },
        Enter: "destination_name",
      },
      valueVerificationFromSuggestionNeeded: true,
      // valueVerificationCompulsionField: "station_to",
    },
  ],
};


const dataObject = { 
  gri_no: "",
  manual_no: "",
  station_to: "",
  station_from: "",
  station_from_name: "",
  station_to_name: "",
  article_shortage: "",
  article_excess: "",
  vehicle_id: "",
  vehicle_no: "",
  created_from: "",
  remarks: "",
  challan_ids: [],
  trip_no: "",
  trip_id: "",
  advanca_bhada: "0",
  narration: "",
  total_weight: "",
  door_del_weight: "",
  payable_weight: "",
  cash_paid: "",
  
  truck_hire: "",
  bilty_no: "",
  bilty_id: "",
  advance_bhada: "",
  last_gri_no : "",
  
  
  balance_bhada: "0",
  input_date: getISTDateTimeLocal(),
  payable_branch: "",
  payable_branch_name: "",
  bhada_paid_branch_name: "",
  net_balance: "0",

};


const griTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Challan No.", className: "text-center table-header" },
  { label: "Challan Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Total Pkgs", className: "text-center table-header" },
  { label: "Weight", className: "text-center table-header" },
  // { label: "To Pay", className: "text-center table-header" },
  // { label: "Paid", className: "text-center table-header" },
  // { label: "To be Billed", className: "text-center table-header" },
];

const griTableItems = [
  {
    type: "text",
    name: "booking_chalan_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "booking_chalan_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_pkgs",
    label: "Total Pkgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_weight",
    label: "Weight",
    className: "form-control-medium-col",
  },
  // {
  //   type: "text",
  //   name: "total_to_pay",
  //   label: "To Pay",
  //   className: "form-control-small-col",
  // },
  // {
  //   type: "text",
  //   name: "total_to_paid",
  //   label: "Paid",
  //   className: "form-control-medium-col",
  // },
  // {
  //   type: "text",
  //   name: "to_be_billed",
  //   label: "To Be Billed",
  //   className: "form-control-medium-col",
  // },
];

function validate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < groupInfo[group_name].length; i++) {
      console.log(groupInfo[group_name][i]);
      let field_object = groupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const popupInfo = {
  "success_header": "GRI Saving Successful",
  "error_header": "Error in GRI Module",
  
  "success_title": "GRI is successfully created with the following info:-",
  "field_label_success": "GRI No.",
  "field_name_success": "gri_no",
  
  "error_title": "Error in GRI module with the following info:-",
  "field_label_error": "Error:",
};

export {
  groupInfo,
  groupNames,
  dataObject,
  griTableHeader,
  griTableItems,
  validate,
  popupInfo
};
